import React, { useEffect, useState } from 'react';

const TurnPhasing = props => {

    return (
        <div className={props.readOnly?'turn-phasing-cnt read-only-mn':'turn-phasing-cnt'}>
            <div>
                <label>RT treatment</label>
                {
                    props.readOnly?<label className='read-only-lb'>{(props.rtSelected !== null && props.rtSelected !== '' && props.phasingList.length > 0)?props.phasingList.filter((el)=>el.id==props.rtSelected)[0].signal:'--'}</label> 
                :<select 
                    onChange={(e) => props.handleSetPhasing(e.target.value, props.dir, "right")}
                    disabled={props.collection.includes(1)||props.collection.includes(3)||props.collection.includes(4)||props.collection.includes(5)||props.collection.includes(6)||props.collection.includes(7) ? props.readOnly?true:false : true}
                    value={props.rtSelected}
                >
                    <option value="">--</option>
                    {
                        props.phasingList.map( (item) => (
                            <option value={item.id}>{item.signal}</option>
                        ))
                    }
                </select>
                }               
            </div>
            <div>
                <label>LT treatment</label>
                {
                   props.readOnly?<label className='read-only-lb'>{(props.ltSelected !== null && props.ltSelected !== '' && props.phasingList.length > 0)?props.phasingList.filter((el)=>el.id==props.ltSelected)[0].signal:'--'}</label>
                :<select
                    onChange={(e) => props.handleSetPhasing(e.target.value, props.dir, "left")}
                    disabled={props.collection.includes(1)||props.collection.includes(3)||props.collection.includes(4)||props.collection.includes(5)||props.collection.includes(6)||props.collection.includes(7) ? props.readOnly?true:false : true}
                    value={props.ltSelected}
                >
                    <option value="">--</option>
                    {
                        props.phasingList.map( (item) => (
                            <option value={item.id}>{item.signal}</option>
                        ))
                    }
                </select>
               }
            </div>
        </div>
      )
}
export default TurnPhasing;